import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './styles/globals.css';
import './i18n/config';
import { setQueryClient } from './utils/queryClient';
import Auth0ProviderWithNavigate from './context/AuthContext';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

setQueryClient(queryClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Auth0ProviderWithNavigate>
        <QueryClientProvider client={queryClient}>
          <ConfigProvider
            theme={{
              token: {
                borderRadius: 9999,
                fontFamily: "'Source Han Sans JP', 'Source Han Sans', sans-serif",
              },
              components: {
                Button: {
                  borderRadius: 9999,
                },
                Input: {
                  borderRadius: 4,
                },
              },
            }}
          >
            <App />
          </ConfigProvider>
        </QueryClientProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </StrictMode>,
);
